// extracted by mini-css-extract-plugin
export default {"app":"todolist_app__sGKXf","todolist":"todolist_todolist__W1gQL"};